//================================================================
//  Component: New Initiative Form
//================================================================

//  Purpose: This contains the form for a new initiative or technology request

//  Properties:
//    - collectionid = {string, Firestore collection id}
//    - documentid = {string, Firestore document id}
//    - task = {object, Firestore document}

//  Example:
//    <NewInitiativeForm
//      collectionid={collectionid}
//      documentid={documentid}
//      task={task}
//    ></NewInitiativeForm>    

// ==============================================================

// Libraries
import React from 'react';

// Contexts

// Components
import LiveField from '../LiveField/LiveField';
import DynamicAddLinkLive from '../DynamicAddLinkLive/DynamicAddLinkLive';
import FileUploadLiveField from '../FileUploadLiveField/FileUploadLiveField';
import DigitalSMEInitiativeLive from '../DigitalSMEInitiativeLive/DigitalSMEInitiativeLive';

// Images
import InfoIcon from '../Images/Icon_Info_Blue.svg';

// CSS

export default function NewInitiativeForm({
    collectionid,
    documentid,
    task
}) {

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='p-2 md:p-0'>

            {/* ------------- New Initiative or Technology ------------- */}

            <h5 className='text-[18px] text-teal-600 mb-2'> New Initiative or Technology </h5>

            {/*  1. Vendor Risk Rating (UpGuard)*/}
            <div className='Form-Row'>
                <label className='font-medium'> 1. Vendor Risk Rating (UpGuard) </label>
                <div className='flex gap-2 rounded-lg border-1 border-[#0972D3] bg-[#E9F7FF] px-3 py-2 items-center'>
                    <img src={InfoIcon} alt='Info icon' width={25} height={25}></img>
                    <p className='mb-0 text-[#424242]'>
                        Not Applicable
                    </p>
                </div>
            </div>

            {/* 2.  Does this initiative relate to any of the following? Select all that apply. */}
            <DigitalSMEInitiativeLive
                initiativeCategories={task?.demandassessment?.initiativecategories || []}
                collectionid={collectionid}
                documentid={documentid}
                fieldpath={'demandassessment.initiativecategories'}
                disabled={true}
            ></DigitalSMEInitiativeLive>

            {/* 3. Does this request align to the Business / Functions / Digital technology strategy? */}
            <LiveField
                type={'choice'}
                collectionid={collectionid}
                documentid={documentid}
                fieldpath={'demandassessment.businessfunctiontechalignment'}
                defaultValue={task?.demandassessment?.businessfunctiontechalignment}
                label={<label className='font-medium'> 3. Does this request align to the Business / Functions / Digital technology strategy? </label>}
                options={[
                    'Yes',
                    'No',
                    'Unknown',
                    'N/A',
                ]}
                disabled={true}
            ></LiveField>

            {/* 4. Please provide any relevant commentary regarding strategy alignment */}
            <LiveField
                type={'multiline'}
                collectionid={collectionid}
                documentid={documentid}
                fieldpath={'demandassessment.strategyalignmentcommentary'}
                label={<label className='font-medium'> 4. Please provide any relevant commentary regarding strategy alignment</label>}
                defaultValue={task?.demandassessment?.strategyalignmentcommentary}
                placeholder={'Summarise strategy alignment'}
                disabled={true}
            ></LiveField>

            {/*  5. Has an options analysis been undertaken? What were the outcomes? */}
            <LiveField
                type={'multiline'}
                collectionid={collectionid}
                documentid={documentid}
                fieldpath={'demandassessment.optionsanalysis'}
                label={<label className='font-medium'> 5. Has an options analysis been undertaken? What were the outcomes?</label>}
                defaultValue={task?.demandassessment?.optionsanalysis}
                placeholder={'Leave blank if unknown or not applicable'}
                disabled={true}
            ></LiveField>

            {/* 6. What is the Digital recommendation for this request? */}
            <LiveField
                type={'multiline'}
                collectionid={collectionid}
                documentid={documentid}
                fieldpath={'demandassessment.digitalrecommendation'}
                label={<label className='font-medium'>6. What is the Digital recommendation for this request?</label>}
                defaultValue={task?.demandassessment?.digitalrecommendation}
                placeholder={'Based on engagement to date, does Digital endorse the scope of this request?'}
                disabled={true}
            ></LiveField>

            {/*  7. Please upload or link any relevant documents in support of this request such as Business case, requirements documentation etc.*/}
            <div className='mt-3'>
                <label className='font-medium'> 7. Please upload or link any relevant documents in support of this request such as Business case, requirements documentation etc.</label>

                {/* Attach Files */}
                <FileUploadLiveField
                    label={<label className='font-medium'> Attach documents </label>}
                    defaultValue={task?.demandassessment?.attacheddocuments}
                    collectionid={collectionid}
                    documentid={documentid}
                    fieldpath={'demandassessment.attacheddocuments'}
                    disabled={true}
                ></FileUploadLiveField>

                {/* Add links */}
                <div>
                    <label className='font-medium mb-2'> Add links </label>
                    <DynamicAddLinkLive
                        links={task?.demandassessment?.links}
                        collectionid={collectionid}
                        documentid={documentid}
                        fieldpath={'demandassessment.links'}
                        disabled={true}
                    ></DynamicAddLinkLive>
                </div>
            </div>

        </div>
    );

}